import { render, staticRenderFns } from "./show-serial.vue?vue&type=template&id=c76cc63e&scoped=true&"
import script from "./show-serial.vue?vue&type=script&lang=js&"
export * from "./show-serial.vue?vue&type=script&lang=js&"
import style0 from "./show-serial.vue?vue&type=style&index=0&id=c76cc63e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76cc63e",
  null
  
)

export default component.exports